import { jsxs as r, Fragment as t, jsx as i } from "@emotion/react/jsx-runtime";
import { CLOSED as e, CLOSED_TEMPORARILY as c } from "@partoohub/api-client";
import { Chip as s } from "@partoohub/ui";
import { isBusinessOpeningSoon as p } from "./utils/isBusinessOpeningSoon.js";
import { useBusinessModalContext as h } from "../../../../BusinessModalContext.js";
const g = ({
  business: n
}) => {
  const a = p(n), {
    translations: o
  } = h();
  return /* @__PURE__ */ r(t, { children: [
    n.status === e && /* @__PURE__ */ i(s, { chipShape: "cube", iconPosition: "right", variant: "danger", dataTrackId: "search-companion-closed-chip", children: o.businessStatus.closed }),
    n.status === c && /* @__PURE__ */ i(s, { chipShape: "cube", variant: "danger", dataTrackId: "search-companion-closed-chip", children: o.businessStatus.closedTemporarily }),
    a && /* @__PURE__ */ i(s, { chipShape: "cube", variant: "primary", dataTrackId: "search-companion-opening-soon-chip", children: o.businessStatus.openingSoon })
  ] });
};
export {
  g as BusinessStatusChip
};
